import { render, staticRenderFns } from "./MantenedorEndpoints.vue?vue&type=template&id=1d1a56ee&scoped=true&"
import script from "./MantenedorEndpoints.vue?vue&type=script&lang=ts&"
export * from "./MantenedorEndpoints.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorEndpoints.vue?vue&type=style&index=0&id=1d1a56ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a56ee",
  null
  
)

export default component.exports